export default __webpack_public_path__ + "static/assets/med_x_powder_1_mask.f9c88a36.png";